import { ComboBox } from 'src/components/credit/ui/comboBox/ComboBox';
import { CREDIT_APPLICANT_IDNUMBER_US_BUSINESS_LABEL } from '../../../../../localization/resouceKeys';
import { handleKeyDownYearMonth } from 'src/utils/helpers';
import { IError } from '../BusinessInfo';
import Input from 'src/components/forms/input';
import { IUser } from 'src/utils/interfaces/user';
import { RadioButton } from 'src/components/ui/radioButton';
import React from 'react';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from '../../../../../utils/useLocalization';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    formatBusinessIdentificationNumber,
    getStateOptions,
} from '../../utils';

interface IProps {
    handlerEdit: Function;
    object: {
        status: string;
        name: string;
        identificationNumber?: string;
        type: string;
        incorporation: string;
        federal: string;
        province: string;
        years: string | number;
        months: string | number;
    };
    errors: {
        status: IError;
        name: IError;
        identificationNumber?: IError;
        type: IError;
        incorporation: IError;
        federal: IError;
        province: IError;
        years: IError;
        months: IError;
    };
    disabled: boolean;
    showFein?: boolean;
}

const ApplicanComponent = ({
    handlerEdit,
    object,
    errors,
    showFein = false,
}: IProps) => {
    const { t } = useTranslation();
    const { businessComercial, occupationIndividualInformation } =
        useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const propertyName = 'applicant';

    const optionsLegalCATypes = [
        {
            value: 'corporation',
            label: businessComercial.OPTION_CORPORATION,
        },
        {
            value: 'partnership',
            label: businessComercial.OPTION_PARTNERSHIP,
        },
        {
            value: 'proprietorship',
            label: businessComercial.OPTION_PROPRIERTORSHIP,
        },
        {
            value: 'goverment',
            label: businessComercial.OPTION_GOVERMENT,
        },
        {
            value: 'municipality',
            label: businessComercial.OPTION_MUNICIPALITY,
        },
        {
            value: 'non-profit',
            label: businessComercial.OPTION_NONPROFIT,
        },
        {
            value: 'other',
            label: businessComercial.OPTION_OTHER,
        },
    ];

    const optionsLegalUSATypes = [
        {
            value: 'corporation',
            label: businessComercial.OPTION_CORPORATION,
        },
        {
            value: 'scorporation',
            label: businessComercial.OPTION_SCORPORATION,
        },
        {
            value: 'llc',
            label: businessComercial.OPTION_LLC,
        },
        {
            value: 'partnership',
            label: businessComercial.OPTION_PARTNERSHIP,
        },
        {
            value: 'solepartnership',
            label: businessComercial.OPTION_SOLEPROP,
        },
        {
            value: 'proprietorship',
            label: businessComercial.OPTION_PROPRIERTORSHIP,
        },
    ];

    const optionsFederalTypes = [
        {
            value: 'federal',
            label: businessComercial.APPLICANT_FEDERAL,
        },
        {
            value: 'province',
            label: businessComercial.APPLICANT_PROVINCE,
        },
    ];

    const isCanada =
        dealerDataInfo?.dealer.country === 'Canada' ||
        dealerDataInfo?.dealer.country === 'CA';
    const stateOptions = getStateOptions(
        isCanada,
        occupationIndividualInformation,
    );

    const optionsLegalTypes = isCanada
        ? optionsLegalCATypes
        : optionsLegalUSATypes;

    const validateIncorporation = (e: any) => {
        const {
            target: { value },
        } = e;
        if (value.length < Number('5') && value <= new Date().getFullYear()) {
            if (
                value.includes('-') === false &&
                value.substring(Number('0')) !== '0'
            ) {
                handlerEdit(e.target, propertyName);
            }
        }
        markCreditFormTouched();
    };

    const notDoubleZero = (value: string) => {
        if (
            value.length === Number('2') &&
            value.substring(Number('1')) === '0' &&
            value === '00'
        )
            return true;
        return false;
    };

    const validateYears = (e: any) => {
        const {
            target: { value },
        } = e;
        if (value.length < Number('3') && value < Number('100')) {
            if (value.includes('-') === false) {
                if (notDoubleZero(value)) return;
                handlerEdit(e.target, propertyName);
            }
        }
        markCreditFormTouched();
    };

    const validateMonths = (e: any) => {
        const {
            target: { value },
        } = e;
        if (value.length < Number('3') && value < Number('12')) {
            if (value.includes('-') === false) {
                if (notDoubleZero(value)) return;
                handlerEdit(e.target, propertyName);
            }
        }
        markCreditFormTouched();
    };

    return (
        <div className={'business-applicant'}>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/1  u-1/1@xs'>
                        <div className='c-form-field'>
                            <label
                                htmlFor='m1l7e063'
                                className='c-form-field__label'
                            >
                                {businessComercial.APPLICANT_TITLE}
                            </label>
                            <div className={'flex'}>
                                <div className='c-form-field__box'>
                                    <RadioButton
                                        name={`typeRadio-${Math.random()}`}
                                        options={optionsLegalTypes.map(
                                            (ele) => ele.value,
                                        )}
                                        onSelect={(value) => {
                                            handlerEdit(
                                                { name: 'status', value },
                                                propertyName,
                                            );
                                        }}
                                        selectedOption={object.status}
                                        labels={optionsLegalTypes.map(
                                            (ele) => ele.label,
                                        )}
                                    />
                                    {errors.status.error &&
                                        errors.status.msg && (
                                            <span className={'c-error-message'}>
                                                {errors.status.msg}
                                            </span>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/1  u-1/1@xs'>
                        <span>
                            {isCanada
                                ? businessComercial.APPLICANT_INFO
                                : businessComercial.APPLICANT_INFOUSA}
                        </span>
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <Input
                                        labelName={
                                            businessComercial.APPLICANT_NAME
                                        }
                                        type={'text'}
                                        name={'name'}
                                        handlerChange={(e: any) => {
                                            handlerEdit(e.target, propertyName);
                                        }}
                                        asTouched={errors.name.error}
                                        asErrors={errors.name.msg}
                                        value={object.name}
                                        maxlength={50}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {showFein && (
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <Input
                                labelName={t(
                                    CREDIT_APPLICANT_IDNUMBER_US_BUSINESS_LABEL,
                                )}
                                type={'text'}
                                name={'identificationNumber'}
                                handlerChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                    handlerEdit(
                                        {
                                            name: 'identificationNumber',
                                            value: formatBusinessIdentificationNumber(
                                                event.target.value,
                                            ),
                                        },
                                        propertyName,
                                    );
                                }}
                                value={object.identificationNumber ?? ''}
                                maxlength={10}
                                asTouched={errors.identificationNumber?.error}
                                asErrors={errors.identificationNumber?.msg}
                            />
                        </div>
                    )}
                    {isCanada && (
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <Input
                                labelName={
                                    businessComercial.APPLICANT_INCORPORATION
                                }
                                type={'text'}
                                name={'incorporation'}
                                handlerChange={validateIncorporation}
                                value={object.incorporation}
                                maxlength={4}
                                min={1927}
                                asErrors={errors.incorporation.msg}
                                asTouched={errors.incorporation.error}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isCanada && (
                <div className='o-fieldset__row'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className={'flex'}>
                                    <div className='c-form-field__box'>
                                        <RadioButton
                                            name={`typeRadio-${Math.random()}`}
                                            options={optionsFederalTypes.map(
                                                (ele) => ele.value,
                                            )}
                                            onSelect={(value) => {
                                                handlerEdit(
                                                    { name: 'federal', value },
                                                    propertyName,
                                                );
                                            }}
                                            selectedOption={object.federal}
                                            labels={optionsFederalTypes.map(
                                                (ele) => ele.label,
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <ComboBox
                                            name={'optionProvince'}
                                            options={stateOptions}
                                            defaultValue={object.province}
                                            placeholder={
                                                businessComercial.APPLICANT_CHOOSEPROVINCE
                                            }
                                            selectedOption={object.province}
                                            onSelect={(value) => {
                                                handlerEdit(
                                                    { name: 'province', value },
                                                    propertyName,
                                                );
                                            }}
                                            disabled={
                                                object.federal.length ===
                                                    Number('0') ||
                                                object.federal === 'federal'
                                            }
                                        />
                                        {errors.province.error &&
                                            errors.province.msg && (
                                                <span
                                                    className={
                                                        'c-error-message'
                                                    }
                                                >
                                                    {errors.province.msg}
                                                </span>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <Input
                            labelName={businessComercial.APPLICANT_YEARS}
                            type={'text'}
                            name={'years'}
                            handlerChange={validateYears}
                            value={object.years}
                            maxlength={2}
                            min={1}
                            asTouched={errors.years.error}
                            asErrors={errors.years.msg}
                            handleKeyPress={handleKeyDownYearMonth}
                        />
                    </div>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <Input
                            labelName={businessComercial.APPLICANT_MONTHS}
                            type={'text'}
                            name={'months'}
                            handlerChange={validateMonths}
                            value={object.months}
                            maxlength={2}
                            min={0}
                            max={11}
                            asTouched={errors.months.error}
                            asErrors={errors.months.msg}
                            handleKeyPress={handleKeyDownYearMonth}
                        />
                    </div>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <Input
                            labelName={businessComercial.APPLICANT_TYPE}
                            type={'text'}
                            name={'type'}
                            handlerChange={(e: any) => {
                                handlerEdit(e.target, propertyName);
                            }}
                            value={object.type}
                            maxlength={30}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplicanComponent;
